import { render } from "./ClinicalTrials.vue?vue&type=template&id=c79ff8a4&scoped=true"
import script from "./ClinicalTrials.vue?vue&type=script&lang=js"
export * from "./ClinicalTrials.vue?vue&type=script&lang=js"

import "./ClinicalTrials.vue?vue&type=style&index=0&id=c79ff8a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79ff8a4"]])

export default __exports__